import axios from 'axios';

import { CONFIG } from '../../../../constants';
import { findFileByOriginalName } from '../../Photos/helper/helper';
import {
  FileUploadInput,
  PreSignedUrlResponse,
  SignedUrlItem,
} from '../../Photos/interface/Photos.interface';

export async function UploadFilesToS3({
  selectedFiles,
  videoFileName,
  onProgress,
  onPreSignedUrlReady,
  onUploadComplete,
}: FileUploadInput) {
  const filesInfo =
    Array.isArray(selectedFiles) &&
    selectedFiles?.map(file => {
      const extension = file?.name?.substring(file?.name?.lastIndexOf('.'));
      const newFileName =
        selectedFiles?.length === 1 && (videoFileName?.length ?? 0) > 0
          ? `${videoFileName}${extension}`
          : file?.name;

      return {
        fileName: newFileName,
        contentType: file?.type,
      };
    });

  try {
    const response = await axios.post(
      `${CONFIG.API_BASE_URL}/documents/common/create-put-signed-url`,
      { filesInfo }
    );
    const preSignedApiResponse: PreSignedUrlResponse = {
      success: true,
      data: response.data,
    };
    onPreSignedUrlReady?.(preSignedApiResponse);

    const putSignedUrl: SignedUrlItem[] = response?.data?.data?.putSignedUrl;

    const uploads = putSignedUrl?.map(item => {
      const validFiles = selectedFiles?.filter(file => file?.name);

      const fileToUpload =
        Array.isArray(validFiles) && validFiles?.length > 0
          ? validFiles?.length === 1
            ? validFiles[0]
            : findFileByOriginalName(validFiles, item?.originalFileName)
          : null;

      if (!fileToUpload) throw new Error('File not found');

      return new Promise<SignedUrlItem>((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', item?.signedUrl);
        xhr.setRequestHeader('Content-Type', item?.contentType);

        xhr.upload.onprogress = event => {
          if (event.lengthComputable && onProgress) {
            const percentComplete = Math.round(
              (event.loaded / event.total) * 100
            );
            onProgress(item?.originalFileName, percentComplete);
          }
        };
        const parts = item?.signedUrl?.split('?');
        const signedUrl =
          Array.isArray(parts) && parts?.length > 0 ? parts[0] : '';

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve({
              fileName: item?.fileName,
              signedUrl: signedUrl,
              originalFileName: item?.originalFileName,
              contentType: item?.contentType,
            });
          } else {
            reject(`Upload failed for ${item?.originalFileName}`);
          }
        };

        xhr.onerror = () => {
          reject(`Error uploading ${item?.originalFileName}`);
        };

        xhr.send(fileToUpload);
      });
    });

    const results = await Promise.all(uploads);

    const fileNameArray =
      Array.isArray(results) &&
      results?.map(item => ({
        fileName: item?.fileName,
        originalFileName: item?.originalFileName,
      }));

    onUploadComplete?.(fileNameArray || []);
    return response;
  } catch (err) {
    console.error('Upload error:', err);

    onPreSignedUrlReady?.({
      success: false,
      error: err,
    });

    onUploadComplete?.([]);
  }
}
